import {
  MaterialReactTable,
  useMaterialReactTable,
  createMRTColumnHelper,
} from "material-react-table";
import {
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Autocomplete,
  Tooltip,
  Chip,
} from "@mui/material";
import { Box, IconButton, Modal } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { usersApi } from "../../app/slices/usersSlice";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";
import LockOpenIcon from "@mui/icons-material/LockOpen";

import { getCityApi } from "../../app/slices/address/citySlice";
import { getStateApi } from "../../app/slices/address/stateSlice";
import axios from "axios";
import Swal from "sweetalert2";
import { ContentCopy, Delete } from "@mui/icons-material";

import NameSearchComponent from "../../components/customTable/NameSearchComponent";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
// import ComplianceReport from "../reports/compliance/ComplianceReport";
import { useNavigate } from "react-router-dom";
const baseUrl = import.meta.env.VITE_BASE_URL;
import { useMediaQuery, useTheme } from "@mui/material";
// import { IoMdCloudUpload } from "react-icons/io";
import { IoMdPricetag } from "react-icons/io";
import { partnerListApi } from "../../app/slices/reports/partnerListSlice";
import Filter from "../../components/Filter";
import { useFormik } from "formik";
// import axiosInstance from "../../utils/axiosInstance";
import axiosInstanceMainUrl from "../../utils/axiosInstanceMainUrl";
import Loader from "../digitalGold/Loader";
import useFilterHandler from "../../components/filterhandler";
import axiosInstance from "../../utils/axiosInstance";

const columnHelper = createMRTColumnHelper();

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

const User = () => {
  const token = localStorage.getItem("token");

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const roleResponse = useSelector((state) => state?.login?.login?.role);

  //-------------logic for show export all data----------

  // const rolePermissions = useSelector((state) => state.login.login.role);
  // console.log("[[[[[[[[[[[[]]]]]]]]]]]]]]]]]]]]]]]----rolepermision------",roleResponse)
  const canExport = roleResponse?.User?.export === 1;

  // console.log("=++++++++++", canExport);

  //-------------------$$----------------------------------

  const navigate = useNavigate();
  const stateLoading = useSelector((state) => state.users.loading);
  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    name: "",
    phone: "",
    uniqueId: "",
    customerRefNo: "",
  });

  const url = `/api/admin/user/list`;

  const {
    handleFilterSubmit,
    handleClearFilters,
    loader,
    results,
    apiCall,
    message,
    error,
    toastTrigger,
  } = useFilterHandler(url, filterData, setFilterData);

  // console.log("tufani---------------------", results);

  const userProfile = (Id) => {
    navigate(`/user-profile/${Id}`);
  };

  const columns = [
    columnHelper.accessor("_id", {
      header: "Customer Ref No",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?._id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>

              {cell.row.original?._id}
            </span>
          </Tooltip>
        );
      },
    }),

    //  columnHelper.accessor("customerRefNo", {
    //       header: "Customer Reference No",
    //       size: 200,
    //       Cell: ({ cell }) => {
    //         const handleCopy = () => {
    //           navigator.clipboard.writeText(cell.row.original?.customerRefNo);
    //           toast.success("copied to clipboard!");
    //         };
    //         return (
    //           <Tooltip title={cell.row.original?.customerRefNo}>
    //             <span>
    //               <IconButton onClick={handleCopy}>
    //                 <ContentCopy />
    //               </IconButton>
    //               {cell.row.original?.customerName || "N/A"}
    //             </span>
    //           </Tooltip>
    //         );
    //       },
    //     }),

    columnHelper.accessor("name", {
      header: "Name",
      size: 200,
      Cell: (cell) => (
        <Button
          style={{ color: "#4a2a7d", fontFamily: "bold" }}
          disabled={roleResponse?.User?.write === 1 ? false : true}
          onClick={() => {
            if (cell.row.original?.name) {
              const Id = cell.row.original?._id;
              userProfile(Id);
            }
          }}
        >
          {cell.row.original?.name}
        </Button>
      ),
    }),
    columnHelper.accessor("phone", {
      header: "Phone",
      size: 150,
    }),

    columnHelper.accessor("email", {
      header: "Email",
      size: 150,
    }),

    // columnHelper.accessor("email", {
    //   header: "Email",
    //   size: 200,
    // }),
    // columnHelper.accessor("is_phone_verified", {
    //   header: "Is Phone Verified",
    //   size: 150,
    // }),

    // columnHelper.accessor("is_email_verified", {
    //   header: "Is Email Verified",
    //   size: 150,
    // }),
    // columnHelper.accessor("country", {
    //   header: "Country",
    //   size: 150,
    // }),
    columnHelper.accessor("pan_number", {
      header: "PAN Number",
      size: 150,
    }),

    columnHelper.accessor("dob", {
      header: "Date Of Birth",
      size: 150,
    }),

    columnHelper.accessor("state", {
      header: "State",
      size: 150,
    }),
    columnHelper.accessor("city", {
      header: "City",
      size: 150,
    }),
    columnHelper.accessor("country", {
      header: "Country",
      size: 150,
    }),
    columnHelper.accessor("uniqueId", {
      header: "Unique ID",
      size: 150,
    }),
    columnHelper.accessor("mmtc_customer_ref", {
      header: "MMTC Customer Ref",
      size: 200,
    }),
    columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 150,
    }),
    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 150,
    }),
    columnHelper.accessor("kyc_status", {
      header: "KYC Status",
      size: 150,
    }),
    columnHelper.accessor("account_status", {
      header: "Account Status",
      size: 150,
    }),
    columnHelper.accessor("sell_flag", {
      header: "Block",
      size: 150,
      Cell: (cell) => (cell.row.original?.sell_flag == 0 ? "No" : "Yes"),
    }),
    // columnHelper.accessor("gender", {
    //   header: "Gender",
    //   size: 150,
    // }),
    // columnHelper.accessor("is_corporate", {
    //   header: "Is Corporate",
    //   size: 150,
    // }),
    columnHelper.accessor("gstin", {
      header: "GSTIN",
      size: 150,
    }),
    // columnHelper.accessor("fcm_token", {
    //   header: "FCM Token",
    //   size: 150,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.fcm_token);
    //       toast.success("FCM token copied to clipboard!");
    //     };

    //     return (
    //       <Tooltip title={cell.row.original?.fcm_token || "Not Available"}>
    //         <IconButton onClick={handleCopy}>
    //           {cell.row.original?.fcm_token ? (
    //             <ContentCopy />
    //           ) : (
    //             <Chip label="Not Available" />
    //           )}
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    // columnHelper.accessor("jwt_token", {
    //   header: "JWT Token",
    //   size: 150,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.jwt_token);
    //       toast.success("JWT token copied to clipboard!");
    //     };

    //     return (
    //       <Tooltip title={cell.row.original?.jwt_token || "Not Available"}>
    //         <IconButton onClick={handleCopy}>
    //           {cell.row.original?.jwt_token ? (
    //             <ContentCopy />
    //           ) : (
    //             <Chip label="Not Available" />
    //           )}
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("is_deleted", {
      header: "Is Deleted",
      size: 150,
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 200,
      Cell: (cell) => cell.row.original.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 200,
      Cell: (cell) => cell.row.original.updatedAt?.split("T")[0],
    }),
  ];

  const dispatch = useDispatch();

  const [UsersList, setUsersList] = useState();

  useEffect(() => {
    apiCall(false);
  }, []);

  useEffect(() => {
    if (!message) return;

    console.log("Message updated:", message);

    if (error) {
      toast.error(message);
    }
    // else {
    //   // toast.success(message);
    // }
  }, [toastTrigger]);

  // const handleExportRows = (rows) => {
  //   console.log("seleted row-----------------------[[[[[[[]]]]]]]]", rows)
  //   console.log("original data", rows.map(r => r.original))

  //   const rowData = rows?.map((row) => row.original);
  //   const csv = generateCsv(csvConfig)(rowData);
  //   download(csvConfig)(csv);
  // };

  //-------------------$-------------------------
  const handleExportRows = () => {
    const selectedRows = table.getSelectedRowModel().flatRows;

    // Get only real data columns (exclude selection & action)
    const visibleColumns = table
      .getAllLeafColumns()
      .filter(
        (col) =>
          col.getIsVisible() &&
          col.id !== "mrt-row-select" &&
          col.id !== "mrt-row-actions",
      )
      .map((col) => col.id);

    const rowData = selectedRows.map((row) => {
      const obj = {};
      visibleColumns.forEach((colId) => {
        obj[colId] = row.original[colId];
      });
      return obj;
    });

    // console.log("Final Export Data:", rowData);

    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  //-------------------$-------------------------

  const handleExportData = () => {
    // console.log("----------------------------<>...............", results);
    const rowData = results?.map((data) => ({
      CustomerRefNo: data?._id || "N/A",
      name: data?.name || "N/A",
      phone: data?.phone || "N/A",
      email: data?.email || "N/A",
      pan_Number: data?.pan_number || "N/A",
      date_of_birth: data?.dob || "N/A",
      country: data?.country || "N/A",
      state: data?.state || "N/A",
      city: data?.city || "N/A",
      uniqueId: data?.uniqueId || "N/A",
      // pan_number: data?.pan_number || "N/A",
      mmtc_customer_ref: data?.mmtc_customer_ref || "N/A",
      partner_id: data?.partner_id || "N/A",
      partner_username: data?.partner_username || "N/A",
      kyc_status: data?.kyc_status || "N/A",
      account_status: data?.account_status || "N/A",
      Block: data.sell_flag == 0 ? "No" : "Yes" || "N/A",
      gstin: data?.gstin || "N/A",
      is_deleted: data?.is_deleted || "N/A",

      // is_deleted: data?.is_deleted || "N/A",
      // partner_id: data?.partner_id || "N/A",
      // partner_username: data?.partner_username || "N/A",
      // otp: data?.otp || "N/A",
      createdAt: data?.createdAt || "N/A",
      updatedAt: data?.updatedAt || "N/A",
      // dob: data?.dob || "N/A",
      // email: data?.email || "N/A",
      // name: data?.name || "N/A",
      // adharUrl: data?.adharUrl || "N/A",
      // isBlocked: data?.isBlocked || "N/A",
    }));

    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  const table = useMaterialReactTable({
    columns,
    data: results || [],
    state: {
      isLoading: stateLoading, // <--- Use this built-in prop for loading state
      // showProgressBars: true, //or
      // showSkeletons:false
      // showCircularProgress: true, //or showSkeletons
    },
    enableRowSelection: true,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    positionActionsColumn: "last",
    enableGlobalFilter: true,
    // enableRowActions: true,
    enableRowActions: roleResponse?.User?.update === 1 && true,
    maxSize: 100,
    muiTableHeadCellProps: {
      sx: {
        background: "#DCDAFF",
        fontWeight: "normal",
        zIndex: "auto", // Remove z-index for the header
      },
    },

    muiTableFooterCellProps: {
      sx: {
        zIndex: "auto", // Remove z-index for the footer
      },
    },
    muiTableBodyRowProps: {
      sx: {
        height: "10px", // Set row height to 30px
      },
    },
    renderRowActions: ({ row }) => [
      <>
        {roleResponse?.User?.update === 1 && (
          <Box style={{ display: "flex", gap: "3px" }}>
            <Tooltip title="Tag User">
              <IconButton
                onClick={() => handleTagOpen(row.original)}
                disabled={row.original.partner_username}
              >
                {/* <IconButton onClick={() => handleOpen(row.original)}> */}
                <IoMdPricetag
                  color={row.original.partner_username ? "" : "#4a2a7d"}
                />
              </IconButton>
            </Tooltip>
            {/* <Tooltip title="Edit User">
              <IconButton onClick={() => handleOpen(row.original)}>
                <EditIcon />
              </IconButton>
            </Tooltip> */}
            <Tooltip
              title={
                row.original.account_status === 0
                  ? "Unblock User"
                  : "Block User"
              }
            >
              <IconButton onClick={() => handleBlockUser(row.original)}>
                {row.original.account_status === 0 ? (
                  <LockOpenIcon />
                ) : (
                  <BlockIcon />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </>,
    ],
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        {!isMobile && canExport && (
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            Export All Data
          </Button>
        )}

        {!isMobile && canExport && (
          <Button
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
            startIcon={<FileDownloadIcon />}
          >
            Export Selected Rows
          </Button>
        )}
      </Box>
    ),
  });

  const [open, setOpen] = useState(false);
  const handleOpen = (data) => {
    setOpen(true);

    let formattedDob = "";
    if (data?.dob) {
      const parts = data.dob.split("-");
      if (parts.length === 3) {
        // Convert "28-08-2025" → "2025-08-28"
        formattedDob = `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }

    setFormData({
      ...data,
      dob: formattedDob, // ✅ Correct format for TextField
    });

    setisPanVerified(Boolean(data.pan_number));
    // ✅ If PAN exists in DB, lock PAN, Email, DOB
    setIsExistingPan(Boolean(data?.pan_number));
    // setIsPanVerified(Boolean(data?.pan_number));

    getAddressApi(data._id);
  };

  // const handleOpen = (data) => {
  //   setOpen(true);
  //   setFormData(data);
  //   // Agar pan_number already hai toh verify ki zarurat nahi
  //   if (data.pan_number) {
  //     setisPanVerified(true);
  //   } else {
  //     setisPanVerified(false);
  //   }

  // };
  const handleClose = () => {
    setOpen(false);
    setisPanVerified(false);
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    // gender: "",
    city: "",
    state: "",
    country: "",
    adharUrl: "",
    pan_number: "",
    zip: "",
    line1: "",
    line2: "",
    statecode: "",
  });
  // console.log("formData: ", formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const url = `/users/${formData._id}`;
      // const url = `${baseUrl}/users/${formData._id}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const dobForApi = formData.dob
        ? formData.dob.split("-").reverse().join("-") // "2025-08-28" → "28-08-2025"
        : "";

      // payload = { ...formData, dob: dobForApi }
      let payload;
      if (!isExistingPan) {
        // if (isPanVerified) {
        payload = {
          msg: {
            LastUpdate: verifiedPanData.msg.LastUpdate,
            // LastUpdate: "",
            Name: verifiedPanData.msg.Name,
            NameOnTheCard: verifiedPanData.msg.NameOnTheCard,
            PanHolderStatusType: verifiedPanData.msg.PanHolderStatusType,
            PanNumber: verifiedPanData.msg.PanNumber,
            STATUS: verifiedPanData.msg.STATUS,
            StatusDescription: verifiedPanData.msg.StatusDescription,
            // dob: "01-01-2000",
            // email: "testing@batuk.in",
            panHolderStatusType: verifiedPanData.msg.panHolderStatusType,
            source_id: verifiedPanData.msg.source_id,

            status: verifiedPanData.status,

            dob: dobForApi,
            email: formData.email,
          },
          addressDetails: {
            // ...formData,
            country: formData.country,
            state: formData.state,
            city: formData.city,
            line1: formData.line1,
            line2: formData.line2,
            zip: formData.zip,
            statecode: formData.statecode,
            // statecode: "up",
          },
        };
      } else {
        payload = {
          addressDetails: {
            // ...formData,
            country: formData.country,
            state: formData.state,
            city: formData.city,
            line1: formData.line1,
            line2: formData.line2,
            statecode: "up",
            zip: formData.zip,
          },
        };
      }
      // console.log("payload: ", payload);

      const response = await axiosInstance.put(url, payload);
      // const response = await axios.put(url, payload, { headers });
      // const response = await axios.put(url, { ...formData, dob: dobForApi }, { headers });
      // const response = await axios.put(url, formData, { headers });
      fetchUserData();

      // dispatch(usersApi());
      // toast.success("User updated successfully");
      await Swal.fire({
        icon: "success",
        title: response.data.message || "User updated successfully",
        showConfirmButton: false,
        timer: 1500,
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = "2000"; // Higher than MUI Modal
          }
        },
      });
      handleClose();
    } catch (error) {
      // toast.error("Error updating user");
      await Swal.fire({
        icon: "error",
        title: "Error updating user",
        text: error?.response?.data?.message || "Something went wrong",
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = "2000"; // Higher than MUI Modal
          }
        },
      });
      handleClose();
    }
  };

  const handleStateChange = (selectedState) => {
    if (selectedState) {
      dispatch(getCityApi(selectedState.id));

      setFormData({
        ...formData,
        state: selectedState.name,
        statecode: selectedState.state_code,
      });
    } else {
      setFormData({ ...formData, state: "", city: "" });
    }
  };

  const handleCityChange = (selectedCity) => {
    if (selectedCity) {
      setFormData({ ...formData, city: selectedCity.name });
    } else {
      setFormData({ ...formData, city: "" });
    }
  };

  const stateSliceResponse = useSelector(
    (state) => state.augmontstateSlice?.data,
  );
  const citySliceResponse = useSelector(
    (state) => state.augmontcitySlice?.data,
  );
  // useEffect(() => {
  //   dispatch(getStateApi());
  // }, []);

  const handleBlockUser = useCallback(async (data) => {
    const account_status = data.account_status === 0 ? 1 : 0;
    const status = data.account_status === 0 ? "Unblock" : "Block";
    const url = `/user/${data._id}`;
    // const url = `${baseUrl}/user/${data._id}`;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await Swal.fire({
        title: `Do you want to ${status} ?`,
        text: `You can ${status === "Unblock" ? "Block" : "Unblock"} anytime`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4d16a4",
        cancelButtonColor: "#d33",
        confirmButtonText: `Yes`,
      });
      if (result.isConfirmed) {
        const response = await axiosInstance.put(url, { account_status }); // Make the API call with the user's ID
        // const response = await axios.put(url, { account_status }, { headers }); // Make the API call with the user's ID

        if (response.data.error) {
          await Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.message || "Something went wrong",
          });
        } else {
          const action =
            response.data.data.account_status === 0 ? "Blocked" : "Unblocked";
          fetchUserData();

          // dispatch(usersApi());

          await Swal.fire({
            icon: "success",
            title: `${action}`,
            text: `User has been successfully ${action}`,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    } catch (error) {
      // toast.error("An error occurred while toggling the user's block status"); // Show error message
      Swal.fire("Error!", "There was a problem deleting the post.", "error");
    }
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [queryParams, setQueryParams] = useState({
    startDate: "",
    endDate: "",
    name: "",
    phone: "",
    uniqueId: "",
    customerRefNo: "",
  });

  const fetchUserData = useCallback(() => {
    let params = {};
    if (searchTerm) {
      params.name = searchTerm;
      params.phone = searchTerm;
      params.uniqueId = searchTerm;
      params.customerRefNo = searchTerm;
    } else if (queryParams.startDate && queryParams.endDate) {
      params.startDate = queryParams.startDate;
      params.endDate = queryParams.endDate;
    }

    if (Object.keys(params).length > 0) {
      dispatch(usersApi(params));
    } else if (
      searchTerm === "" ||
      (!queryParams.startDate && !queryParams.endDate)
    ) {
      dispatch(usersApi(params));
    }
  }, [dispatch, searchTerm, queryParams]);

  // useEffect(() => {
  //   fetchUserData();
  // }, [fetchUserData, handleBlockUser]);

  const handleSearchByDate = (startDate, endDate) => {
    setSearchTerm("");
    setQueryParams({
      startDate,
      endDate,
      startDate,
      endDate,
      name,
      phone,
      uniqueId,
      customerRefNo,
    });
  };

  const handleSearchByName = (name) => {
    // setQueryParams({ startDate: null, endDate: null });
    setSearchTerm(name);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check

  const [isPanVerified, setisPanVerified] = useState(false);
  const [isExistingPan, setIsExistingPan] = useState(false); // Whether PAN exists in DB

  // console.log("isPanVerified: ", isPanVerified);
  const [verifiedPanData, setverifiedPanData] = useState({});
  // console.log("verifiedPanData: ", verifiedPanData);

  const PanVerify = async (e) => {
    e.preventDefault();
    try {
      const url = `/panVerify`;
      // const url = `${baseUrl}/panVerify`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axiosInstance.post(
        url,
        { pannumber: formData.pan_number },
        // { headers }
      );
      // const response = await axios.post(
      //   url,
      //   { pannumber: formData.pan_number },
      //   { headers }
      // );

      let apiData = response?.data;

      if (!apiData?.data || apiData.data.length === 0) {
        await Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text: "Invalid response from server.",
          backdrop: true,
          didOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = "2000"; // Higher than MUI Modal
            }
          },
        });
        return;
      }

      let parsedData;
      try {
        parsedData = JSON.parse(apiData.data[0]);
        setverifiedPanData(parsedData);
        // console.log("parsedData: ", parsedData);
      } catch (err) {
        await Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text: "Something went wrong while parsing data.",
          backdrop: true,
          didOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = "2000"; // Higher than MUI Modal
            }
          },
        });
        return;
      }

      // SUCCESS CASE
      if (parsedData?.status === 1) {
        const panDetails = parsedData?.msg;
        // console.log("panDetails: ", panDetails);

        await Swal.fire({
          title: "PAN Verified Successfully!",
          html: `
        <b>Name:</b> ${panDetails?.Name || "N/A"}<br />
        <b>PAN Number:</b> ${panDetails?.PanNumber || "N/A"}<br />
        <b>Status:</b> ${panDetails?.STATUS || "N/A"}<br />
        <b>Description:</b> ${panDetails?.StatusDescription || "N/A"}
        `,
          icon: "success",
          confirmButtonText: "OK",
          backdrop: true, // force overlay above modal
          didOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = "2000"; // Higher than MUI Modal
            }
          },
        });

        setisPanVerified(true);
        // handleClose();
        // ✅ If PAN is newly verified, keep email & dob editable
        if (!isExistingPan) {
          setIsExistingPan(false);
        }
      } else {
        // ERROR CASE
        await Swal.fire({
          icon: "error",
          title: "PAN Verification Failed",
          text: parsedData?.msg || "Incorrect PAN",
          confirmButtonText: "Retry",
          backdrop: true,
          didOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = "2000"; // Higher than MUI Modal
            }
          },
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Server Error",
        text: error?.response?.data?.message || "Something went wrong",
        backdrop: true,
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = "2000";
          }
        },
      });
    }
  };

  //////////////////////////////////////////// partner tag //////////////////////////////////////////
  const [tagOpen, setTagOpen] = useState(false);
  const handleTagOpen = (data) => {
    setTagOpen(true);

    setTagFormData({
      partner_username: data?.partner_username || "", // pre-fill if exists
      partner_id: data?.partner_id || "", // pre-fill partner id
      _id: data?._id || "", // customerRefNo from row id
    });
  };

  const handleTagClose = () => setTagOpen(false);
  const [tagFormData, setTagFormData] = useState({
    partner_username: "",
    partner_id: "", // Added for pre-filled selection
    _id: "", // Customer Ref No (comes from selected row)
  });

  // console.log("tagFormData: ", tagFormData);

  const [tagErrors, setTagErrors] = useState({
    partner_username: "",
  });

  const handleTagInputChange = (e) => {
    const { name, value } = e.target;
    setTagFormData((prev) => ({ ...prev, [name]: value }));
    setTagErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const tagValidate = () => {
    let errors = {};
    let isValid = true;

    if (!tagFormData.partner_username) {
      errors.partner_username = "Partner Username is required";
      isValid = false;
    }

    setTagErrors(errors);
    return isValid;
  };

  const tagApi = async () => {
    try {
      const url = `/tagPartner`;
      // const url = `${baseUrl}/tagPartner`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axiosInstance.post(
        url,
        {
          partner_username: tagFormData.partner_username,
          customerRefNo: tagFormData._id, //  Send customerRefNo from selected row
        },
        // { headers }
      );
      // const response = await axios.post(
      //   url,
      //   {
      //     partner_username: tagFormData.partner_username,
      //     customerRefNo: tagFormData._id, //  Send customerRefNo from selected row
      //   },
      //   { headers }
      // );

      fetchUserData();
      // dispatch(usersApi());

      await Swal.fire({
        icon: "success",
        title: response.data.message || "Partner Tagged successfully",
        showConfirmButton: false,
        timer: 1500,
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = "2000";
          }
        },
      });
      handleTagClose();
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error updating Tag Partner",
        text: error?.response?.data?.message || "Something went wrong",
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = "2000";
          }
        },
      });
      handleTagClose();
    }
  };

  const handleTagSubmit = async (e) => {
    e.preventDefault();

    if (!tagValidate()) return;

    await tagApi();
  };

  const partnerListsliceResponse = useSelector(
    (state) => state.partnerList.partnerList.data,
  );
  // console.log("partnerListsliceResponse: ", partnerListsliceResponse);
  useEffect(() => {
    dispatch(partnerListApi());
  }, [dispatch]);

  // address api
  const getAddressApi = async (_id) => {
    try {
      const url = `/getAddress/${_id}`;
      // const url = `${baseUrl}/getAddress/${_id}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axiosInstance.get(
        url,
        // { headers }
      );
      // const response = await axios.get(
      //   url,
      //   { headers }
      // );
      // console.log("response: ", response);
      // console.log("response: getAddressApi line 1  ", response.data.data[0].line1);
      // console.log("response: getAddressApi line 2", response.data.data[0].line2);
      setFormData((prev) => ({
        ...prev,
        line1: response?.data?.data[0]?.line1 || "",
        line2: response?.data?.data[0]?.line2 || "",
        zip: response?.data?.data[0]?.zip || "",
      }));
      // setFormData({
      //   ...data,
      //   dob: formattedDob, // ✅ Correct format for TextField
      // });
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error while get address",
        text: error?.response?.data?.message || "Something went wrong",
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) {
            swalPopup.style.zIndex = "2000";
          }
        },
      });
    }
  };
  // ====================NEW CODE===========================
  // const handleClearFilters = () => {
  //   // Reset filter state
  //   console.log("reset==============")
  //   setFilterData((prev) => {
  //   const cleared = {};
  //   console.log("fffffffffffffffff")
  //   Object.entries(prev).forEach(([key, value]) => {
  //     if (typeof value === "boolean") cleared[key] = false;
  //     else cleared[key] = "";
  //   });

  //   // Onclear()

  //   return cleared;
  // });
  //   const params = false
  //   apiCall(params)

  // };

  // const [loader, setloader] = useState(true)

  // // const handleFilterSubmit = async (event) => {
  // //   event.preventDefault();

  // //   apiCall()

  // // };

  // const apiCall = async (params = true) => {
  //   try {

  //     let config = {};

  //     if (params) {
  //       config = {
  //         params: {
  //           ...filterData
  //         },
  //       };
  //     }

  //     const response = await axiosInstanceMainUrl.get(
  //       "/api/admin/user/list",
  //       config
  //     );

  //     const { data, message, error } = response.data;

  //     console.log("API RESPONSE:", response.data);
  //     console.log("DATA:", data);

  //     if (!error) {
  //       setloader(false)
  //       setResults(data);
  //     }
  //   } catch (err) {
  //     console.error("API ERROR:", err);

  //     // optional: show toast / alert
  //     // toast.error(err.response?.data?.message || "Something went wrong");
  //   }
  // };
  ///

  return (
    <>
      <Filter
        filterData={filterData}
        onFilterSubmit={handleFilterSubmit}
        Onclear={handleClearFilters}
        page={"User"}
        setFilterData={setFilterData}
      />
      {/*  */}
      <Box>
        {/* <Box
          display="flex"
          flexDirection={isMobile ? "column" : "row"} // ✅ Stack vertically on mobile
          alignItems={isMobile ? "stretch" : "center"}
          justifyContent={isMobile ? "flex-start" : "space-between"}
       
        >
          Search by Name
          <Box width={isMobile ? "100%" : "40%"}>
            <NameSearchComponent onSearch={handleSearchByName} placeholderName="Search by Name or Phone" />
          </Box>

          Search by Date
          <Box
            width={isMobile ? "100%" : "55%"}
            mt={isMobile ? 2 : 0} // ✅ Add margin on mobile
            ml={isMobile ? 0 : 0} // ✅ Add margin on mobile
          >
            <DateSearchComponent onSearch={handleSearchByDate} />
          </Box>
        </Box> */}

        {/* Users Table */}
        <Box mt={2}>
          {loader ? <Loader /> : <MaterialReactTable table={table} />}
        </Box>
      </Box>

      {/* user edit modal  */}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        // sx={{ zIndex: 1200 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? 380 : 600,
            bgcolor: "background.paper",

            boxShadow: 24,
            p: 3,
          }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={1.5}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Country"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  disablePortal
                  id="state-autocomplete"
                  options={stateSliceResponse?.data || []}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  size="small"
                  value={
                    formData.state
                      ? { name: formData.state }
                      : stateSliceResponse?.data?.find(
                          (option) => option.name === formData.state,
                        ) || null
                  }
                  onChange={(_, value) => handleStateChange(value)}
                  renderInput={(params) => (
                    <TextField {...params} label="State" />
                  )}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  disablePortal
                  id="city-autocomplete"
                  options={citySliceResponse?.data || []}
                  getOptionLabel={(option) => option.name || ""}
                  fullWidth
                  size="small"
                  value={
                    formData.city
                      ? { name: formData.city }
                      : citySliceResponse?.data?.find(
                          (option) => option.name === formData.city,
                        ) || null
                  }
                  onChange={(_, value) => handleCityChange(value)}
                  renderInput={(params) => (
                    <TextField {...params} label="City" />
                  )}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Zip"
                  name="zip"
                  value={formData.zip || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,6}$/.test(value)) {
                      setFormData({ ...formData, zip: value });
                    }
                  }}
                  error={
                    Boolean(formData.zip) && String(formData.zip).length !== 6
                  }
                  helperText={
                    Boolean(formData.zip) && String(formData.zip).length !== 6
                      ? "Pincode must be 6 digits"
                      : ""
                  }
                  inputProps={{
                    maxLength: 6,
                    inputMode: "numeric",
                  }}
                  required
                  InputLabelProps={{ shrink: true }}
                />
                {/* <TextField
                  fullWidth
                  size="small"
                  label="Zip"
                  name="zip"
                  value={formData.zip}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,6}$/.test(value)) {
                      setFormData({ ...formData, zip: value });
                    }
                  }}
                  error={formData.zip && formData.zip.length !== 6}
                  helperText={
                    formData.zip && formData.zip.length !== 6
                      ? "Pincode must be 6 digits"
                      : ""
                  }
                  inputProps={{
                    maxLength: 6,
                    inputMode: "numeric",
                  }}
                  required
                  InputLabelProps={{ shrink: true }}
                /> */}
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Address 1"
                  name="line1"
                  value={formData.line1}
                  onChange={handleChange}
                  type="text"
                  required
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Address 2"
                  name="line2"
                  value={formData.line2}
                  onChange={handleChange}
                  type="text"
                  required
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isExistingPan} // ✅ Email locked only for existing PAN
                  required
                />
                {/* <TextField
                  fullWidth
                  size="small"
                  label="Email"
                  name="email"
                  // disabled={Boolean(formData?.pan_number && formData?.pan_number?.length >= 10)}
                  disabled={isPanVerified}
                  value={formData.email}
                  onChange={handleChange}
                  type="email"
                /> */}
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="DOB"
                  name="dob"
                  type="date"
                  value={formData.dob}
                  onChange={handleChange}
                  disabled={isExistingPan} // ✅ DOB locked only for existing PAN
                  InputLabelProps={{ shrink: true }}
                  required
                />
                {/* <TextField
                  fullWidth
                  size="small"
                  label="Date of Birth"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                /> */}
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    name="gender"
                    size="small"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  disabled
                  label="Aadhar URL"
                  name="adharUrl"
                  value={formData.adharUrl}
                  onChange={handleChange}
                />
              </Grid> */}
              <Grid item xs={12} sm={6}>
                {/* <TextField
                    fullWidth
                    size="small"
                    disabled={formData.pan_number?.length >= 11}
                    label="PAN Number"
                    name="pan_number"
                    value={formData.pan_number}
                    onChange={handleChange}
                  /> */}

                {/* <TextField
                  fullWidth
                  size="small"
                  disabled={Boolean(formData?.pan_number && formData?.pan_number?.length >= 10)}
                  label="PAN Number"
                  name="pan_number"
                  value={formData.pan_number}
                  onChange={handleChange}
                /> */}

                <TextField
                  fullWidth
                  size="small"
                  label="PAN Number"
                  name="pan_number"
                  value={formData.pan_number}
                  onChange={handleChange}
                  disabled={isExistingPan} // ✅ PAN disabled only if already in DB
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={PanVerify}
                  fullWidth
                >
                  Verify PAN
                </Button> */}
                <Button
                  variant={isPanVerified ? "outlined" : "contained"}
                  // sx={{ color: isPanVerified ? "green" : "primary" }}
                  color="primary"
                  onClick={PanVerify}
                  fullWidth
                  disabled={
                    formData?.pan_number?.length !== 10 || isPanVerified
                  }
                  sx={{
                    bgcolor: "#4B0082", // purple background
                    color: "#fff", // white text
                    "&.Mui-disabled": {
                      bgcolor: isPanVerified ? "#60D667" : "#4B0082", // disabled pe bhi same background
                      color: "#fff", // disabled pe bhi white text
                      opacity: 0.7, // thoda halka karna ho toh
                    },
                  }}
                >
                  {isPanVerified ? "PAN Verified" : "Verify PAN"}
                </Button>
              </Grid>
              <Grid item xs={6} sm={6}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                  fullWidth
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={6} sm={6}>
                {/* <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Update
                </Button> */}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={!isPanVerified}
                  // disabled={!isPanVerified && !formData.pan_number}
                  sx={{
                    bgcolor: "#4B0082", // purple background
                    color: "#fff", // white text
                    "&.Mui-disabled": {
                      bgcolor: "#4B0082", // disabled pe bhi same background
                      color: "#fff", // disabled pe bhi white text
                      opacity: 0.7, // thoda halka karna ho toh
                    },
                  }}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>

      {/* tag modal  */}
      <>
        <Modal
          open={tagOpen}
          onClose={handleTagClose}
          aria-labelledby="tag-modal-title"
          aria-describedby="tag-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              // border: "2px solid #000",
              boxShadow: 24,
              p: 3,
            }}
          >
            <Box
              component="form"
              onSubmit={handleTagSubmit}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                mt: 1,
              }}
            >
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} md={12}>
                  <Autocomplete
                    size="small"
                    options={partnerListsliceResponse || []}
                    getOptionLabel={(option) =>
                      `${option.name} (${option.username})`
                    }
                    filterOptions={(options, { inputValue }) =>
                      options.filter(
                        (option) =>
                          option.name
                            .toLowerCase()
                            .includes(inputValue.toLowerCase()) ||
                          option.username
                            .toLowerCase()
                            .includes(inputValue.toLowerCase()),
                      )
                    }
                    // ✅ Pre-filled value if partner exists, otherwise null
                    value={
                      partnerListsliceResponse?.find(
                        (option) =>
                          option.username === tagFormData.partner_username,
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setTagFormData((prev) => ({
                          ...prev,
                          partner_username: newValue.username,
                          partner_id: newValue._id,
                        }));
                      } else {
                        setTagFormData((prev) => ({
                          ...prev,
                          partner_username: "",
                          partner_id: "",
                        }));
                      }
                      setTagErrors((prev) => ({
                        ...prev,
                        partner_username: "",
                      }));
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option._id === value._id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search Partner"
                        variant="outlined"
                        error={!!tagErrors.partner_username}
                        helperText={tagErrors.partner_username}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  mt: 1,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleTagClose}
                  fullWidth
                >
                  Back
                </Button>

                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={!tagFormData.partner_username}
                  sx={{
                    bgcolor: "#4B0082",
                    color: "#fff",
                    "&.Mui-disabled": {
                      color: "#fff",
                      opacity: 0.7,
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </>
    </>
  );
};

export default User;
